import { NumberField } from 'module/types/filter-field/field/filterable-field';
import { InputNumber as RawInputNumber } from 'module/ui/components/atoms/input/input-number';
import { NoValue } from 'module/ui/components/atoms/no-value/empty-cell';
import { FC } from 'react';
import { EditableProps } from './editable-props';

interface Props extends Partial<EditableProps<number>> {
  field: NumberField;
}

const InputNumber = RawInputNumber;

export const NumberFieldValue: FC<React.PropsWithChildren<Props>> = ({
  field,
  id,
  editable,
  onChange,
  onKeyDown,
}) =>
  !editable ? (
    field.value == null ? (
      <NoValue />
    ) : (
      <>{field.value}</>
    )
  ) : (
    <InputNumber
      id={id}
      autoFocus
      data-cy={`ag-grid.${field.type}.editor`}
      value={field.value}
      min={field.metaData?.range?.min}
      max={field.metaData?.range?.max}
      onChange={(latest) => onChange?.(latest as number)}
      onKeyDown={onKeyDown}
    />
  );
